import React, { useState } from "react";
import { LuMail } from "react-icons/lu";
import AgreementDocument from "./AgreementDocument";
import "./agreementReview.css";

export default function AgreementReview({
  agreement,
  reviewed,
  onReviewed,
  busy,
  canWrite,
  onEdit,
  onSend,
}) {
  const a = agreement;
  const supplierPerson = a.supplierRepresentative?.name || a.supplier.name;
  const address = (name, email) => (email ? `${name} <${email}>` : name);
  const defaultMessage = `Hi ${
    a.supplierRepresentative?.name?.trim().split(/\s+/)[0] || a.supplier.name
  },\n\n${
    a.buyer.name
  } invites you to review a recipient created tax invoice (RCTI) agreement on behalf of ${
    a.supplier.name
  }.\n\nThe agreement lets ${
    a.buyer.name
  } determine the value and issue RCTIs for your covered taxable supplies: ${
    a.scope
  } Please review all terms and confirm your authority before signing.`;
  const [subject, setSubject] = useState(`Please sign your RCTI agreement — ${a.buyer.name}`);
  const [message, setMessage] = useState(defaultMessage);
  return (
    <>
      <div className="agreement-review-status">
        <span className="rcti-agreement-badge rcti-agreement-badge--proposed">
          Proposed · Not sent
        </span>
        <span>Supplier signature pending · Wording v{a.version}</span>
      </div>
      <div className="agreement-review-columns">
        <AgreementDocument agreement={a} preview />
        <aside className="agreement-review-sidebar">
          <section className="rcti-agreement-card agreement-review-invitation">
            <h2>
              <LuMail aria-hidden="true" />
              Invitation email
            </h2>
            <label>
              To
              <input
                readOnly
                value={address(supplierPerson, a.supplier.emailAddress)}
              />
            </label>
            <label>
              From
              <input
                readOnly
                value={address(a.buyer.name, a.buyer.emailAddress)}
              />
            </label>
            <label>
              Subject
              <input
                value={subject}
                onChange={(event) => setSubject(event.target.value)}
                disabled={busy}
                maxLength={200}
              />
            </label>
            <label>
              Message
              <textarea value={message} onChange={(event) => setMessage(event.target.value)} disabled={busy} maxLength={10000} rows={7} />
            </label>
            <div
              className="agreement-review-email-card"
              aria-label="Invitation email preview"
            >
              <strong>{a.buyer.name} invites you to sign</strong>
              <p>RCTI agreement · Wording v{a.version}</p>
              <button
                type="button"
                className="agreement-email-preview-cta"
                disabled
                aria-describedby="agreement-email-preview-help"
              >
                Review &amp; sign agreement
              </button>
              <p
                id="agreement-email-preview-help"
                className="agreement-review-muted"
              >
                Email preview only. The supplier’s private signing link is
                created when you send the invitation.
              </p>
              <p>
                Review the complete agreement and confirm your authority before
                accepting. The supplier has seven days to sign.
              </p>
            </div>
          </section>
          <section className="rcti-agreement-card agreement-review-before">
            <h2>Before you send</h2>
            <p>
              The invitation asks {a.supplier.name} to review and sign. Sending
              does not activate the agreement.
            </p>
            <hr />
            <p>
              After sending, the agreement is marked Awaiting signature in the
              register. The supplier receives a signing invitation.
            </p>
            <p className="agreement-review-muted">
              No legal RCTI number, tax invoice or payable is generated by this
              action.
            </p>
            <label className="rcti-consent">
              <input
                type="checkbox"
                checked={reviewed}
                onChange={(event) => onReviewed(event.target.checked)}
                disabled={busy}
              />
              I have reviewed the agreement and supplier recipient.
            </label>
          </section>
          <div className="agreement-review-note">
            <strong>Seven days to sign</strong>
            <p>
              The invitation expires if unsigned after seven days. Once
              accepted, the agreement continues while eligible, unless either
              party suspends it.
            </p>
          </div>
        </aside>
      </div>
      <footer className="agreement-review-footer">
        <button
          type="button"
          className="rcti-button-secondary"
          disabled={busy}
          onClick={onEdit}
        >
          ← Edit agreement
        </button>
        <button
          type="button"
          disabled={
            busy ||
            !canWrite ||
            !reviewed ||
            !a.scope.trim() ||
            !a.buyerSignature
          }
          onClick={() => onSend({ subject, message })}
        >
          {busy ? "Sending…" : "Send agreement for signature"}
        </button>
      </footer>
    </>
  );
}
